import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Dropdown} from 'semantic-ui-react';

const CardOnFile = ({
  cardsOnFile,
  onChangeCardSelection,
  selectedCard,
  processorName,
}) => (
  <div>
    <Dropdown
      fluid
      onChange={onChangeCardSelection}
      options={[
        {
          key: 0,
          text: 'Select existing card',
          value: '0',
        },
        ...cardsOnFile.map(x => ({
          key: x.externalCustomerId,
          text: `Saved on ${processorName} (${x.cardType} ${x.lastFourDigits})`,
          value: x.externalCustomerId,
        })),
      ]}
      selection
      value={selectedCard}
    />

    {selectedCard === '0' && <Divider horizontal>or</Divider>}
  </div>
);

CardOnFile.propTypes = {
  cardsOnFile: PropTypes.arrayOf(
    PropTypes.shape({
      cardType: PropTypes.string.isRequired,
      externalCustomerId: PropTypes.string.isRequired,
      lastFourDigits: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedCard: PropTypes.string.isRequired,
  processorName: PropTypes.string.isRequired,

  // functions
  onChangeCardSelection: PropTypes.func.isRequired,
};

export default CardOnFile;



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/CardOnFile.js